export default IconMapEast => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-map-east" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
  <path d="M14 9h-4v6h4" />
  <path d="M10 12h2.5" />
</svg>`;